module.exports = __webpack_public_path__ + "images/warehouse1.0264344.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/warehouse1.jpg
// module id = 643
// module chunks = 0